export default {
      id: "ic_linkedin-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_linkedin-usage",
      toString: function () {
        return this.url;
      }
    }